export var animateDuration = 250;